import { useEffect, useState } from 'react';

import { GuideName } from '@app/api/guides';

import SelectField from '../../../select-field';
import { FilterComponentProps } from '../../types';
import { useFetchOptions } from '../../hooks/use-fetch-options';

export function SelectFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;
  const [options, setOptions] = useState<EntityBase[]>([]);
  const fetch = useFetchOptions(filter.source as GuideName, filter.onOptionsFetch);
  
  useEffect(() => {
    (async () => {
      setOptions(await fetch());
    })();
  }, []);

  return <SelectField 
    id={filter.name.toString()} 
    label={filter.label} 
    value={filter.value as EntityBase}   
    options={options}
    onChange={(value) => {
        onChange({
          ...filter,
          value
        });
      }}
  />;
}